import { memo } from 'react';
import { StepViewComponentProps } from '../stepDescriptor/types';
import TextCollectionTaskComponent from './TextCollectionTaskComponent';

function TextCollectionPinnedViewComponent(props: StepViewComponentProps) {
  return <TextCollectionTaskComponent {...props} isPinnable isPinnedView />;
}

export default memo(TextCollectionPinnedViewComponent);
